export default function ServiceInfo() {
  return (
    <div style={{ padding: 16 }}>
      <h3>About Service</h3>
      <p>
        Service collects sermon and slideshow items that are ready to be shown
        on church screens.
      </p>
    </div>
  );
}
